<template>
  <b-row v-if="$route.name === 'EXCMNoteCreate'">
    <b-col cols="12">
      <b-card>
        <EXCMNoteForm
          :handle-submit="onSendForm"
          :handle-update-field="updateField"
          :values="item"
          :errors="violations" />
      </b-card>
    </b-col>
  </b-row>
  <b-row v-else>
    <b-col cols="12">
      <EXCMNoteForm
        :handle-submit="onSendForm"
        :handle-update-field="updateField"
        :values="item"
        :id-case="idCase"
        :id-firm="idFirm"
        :id-organization-lead="idOrganizationLead"
        :errors="violations" />
    </b-col>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import EXCMNoteForm from './Form'

const { mapGetters, mapActions } = createNamespacedHelpers('excmnote/create')

export default {
  components: {
    EXCMNoteForm
  },

  props: {
    idCase: {
      required: false
    },
    idFirm: {
      required: false
    },
    idOrganizationLead: {
      required: false
    }
  },

  data () {
    return {
      item: {
        idCase: this.idCase,
        idUserData: this.idFirm,
        idOrganizationLead: this.idOrganizationLead,
        idCategory: null
      }
    }
  },

  computed: mapGetters([
    'error',
    'isLoading',
    'created',
    'violations'
  ]),

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (created && this.$route.name === 'EXCMNoteCreate') {
        this.$router.go(-1)
      }
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      this.create(this.item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
